import type { BillingPlanDTO } from '../../global';

/** Satın alınabilir planın fiyatı, kendi para biriminde (ör. ₺299,00). */
export function formatPlanPrice(plan: Pick<BillingPlanDTO, 'price' | 'currencyCode'>): string {
  try {
    return new Intl.NumberFormat(undefined, { style: 'currency', currency: plan.currencyCode || 'TRY' }).format(plan.price);
  } catch {
    return `${plan.price} ${plan.currencyCode}`;
  }
}
